/** Ids that may key localStorage punches / shifts / time-off for one employee. */
export function employeeIdAliases(employee: {
  id: string;
  legacyId?: string;
}): string[] {
  if (employee.legacyId && employee.legacyId !== employee.id) {
    return [employee.id, employee.legacyId];
  }
  return [employee.id];
}

export function matchesEmployeeId(
  storedId: string,
  aliases: readonly string[]
): boolean {
  return aliases.includes(storedId);
}

/** Normalize a single id or alias list for dual-key localStorage reads. */
export function asEmployeeIdList(
  employeeId: string | readonly string[]
): string[] {
  return typeof employeeId === 'string' ? [employeeId] : [...employeeId];
}
